const BarGraphData = [
  {
    class: "V",
    attendance: 10,
  },
  {
    class: "VI",
    attendance: 19,
  },
  {
    class: "VII",
    attendance: 18,
  },
  {
    class: "VIII",
    attendance: 34,
  },
  {
    class: "IX",
    attendance: 29,
  },
  {
    class: "X",
    attendance: 30,
  },
];

export default BarGraphData;
